var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.4037 8.66797C22.2304 9.31797 22.1654 10.033 22.1654 10.8346V17.3346H11.332V13.0013C11.332 10.618 13.282 8.66797 15.6654 8.66797H22.4037Z",
    fill: "#2FF77A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1654 41.1654V17.332H11.332C6.9987 17.332 4.83203 19.4987 4.83203 23.832V41.1654C4.83203 45.4987 6.9987 47.6654 11.332 47.6654H28.6654C24.332 47.6654 22.1654 45.4987 22.1654 41.1654ZM15.1237 36.832C15.1237 37.7204 14.387 38.457 13.4987 38.457C12.6104 38.457 11.8737 37.7204 11.8737 36.832V28.1654C11.8737 27.277 12.6104 26.5404 13.4987 26.5404C14.387 26.5404 15.1237 27.277 15.1237 28.1654V36.832Z",
    fill: "#2FF77A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.8346 47.6654H28.668C24.3346 47.6654 22.168 45.4987 22.168 41.1654V10.832C22.168 6.4987 24.3346 4.33203 28.668 4.33203H41.668C46.0013 4.33203 48.168 6.4987 48.168 10.832V41.1654C48.168 45.4987 46.0013 47.6654 41.668 47.6654H39.5013",
    fill: "#2FF77A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4987 38.9987V47.6654H30.832V38.9987C30.832 37.807 31.807 36.832 32.9987 36.832H37.332C38.5237 36.832 39.4987 37.807 39.4987 38.9987Z",
    fill: "#2FF77A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.832 29.7904C29.9437 29.7904 29.207 29.0537 29.207 28.1654V17.332C29.207 16.4437 29.9437 15.707 30.832 15.707C31.7204 15.707 32.457 16.4437 32.457 17.332V28.1654C32.457 29.0537 31.7204 29.7904 30.832 29.7904Z",
    fill: "#2FF77A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 29.7904C38.6117 29.7904 37.875 29.0537 37.875 28.1654V17.332C37.875 16.4437 38.6117 15.707 39.5 15.707C40.3883 15.707 41.125 16.4437 41.125 17.332V28.1654C41.125 29.0537 40.3883 29.7904 39.5 29.7904Z",
    fill: "#2FF77A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/buildingIcon.e433d729791bfd87937e4381f030d8a1.svg";
export { ForwardRef as ReactComponent };